import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
// import GenAIAskQuestion from "./GenAIAskQuestion"
import GenAIAskQuestion from "./GenAIAskQuestion2_0"
import { GenAIAnsweringContext } from './GenAIAnsweringContextProvider';
import GenAIAnsweringDisclaimer from './GenAIAnsweringDisclaimer'
import ApiServices from "../../utils/apiServices";
import Dropzone from 'react-dropzone';
import AlertMessagePopUpModal from "../GenAIPopUp/AlertMessagePopUpModal";
import GenAIMyAvatar from "../header/GenAIMyAvatar"

class GenAIHome extends Component {
    static contextType = GenAIAnsweringContext;
    constructor(props) {
        super(props);
        let _showDisclaimerPopup = true;
        let strShowDisclaimerPopup = localStorage.getItem('showGenAIAnsweringDisclaimer');
        if (strShowDisclaimerPopup) {
            _showDisclaimerPopup = !JSON.parse(strShowDisclaimerPopup);
        }
        this.state = {
            customWidth: props.customWidth,
            customHeight: props.customHeight,
            showDisclaimerPopup: _showDisclaimerPopup,
            filestoUpload: {},
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
        }
    }
    componentDidMount = async () => {
        await this.context.getLatestAnswerThread();
    }
    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#EB1700",
            alertMessageShowModal: true
        })
    }
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#EB1700",
            alertMessageShowModal: true
        })
    }
    closeAlertMessage = () => {
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            alertMessageShowModal: false,
            showPreview: false
        })
    }
    handleDisclaimerClose = async () => {
        let strShowDisclaimerPopup = localStorage.getItem('showGenAIAnsweringDisclaimer');
        if (strShowDisclaimerPopup && !JSON.parse(strShowDisclaimerPopup)) {
            let service = new ApiServices();
            let wwid = JSON.parse(localStorage.getItem("wwid"));
            await service.UpdateDisclaimerStatus(wwid, 'isshowgenaiansweringdisclaimer', true);
        }
        this.setState({ showDisclaimerPopup: false });
        localStorage.setItem('showGenAIAnsweringDisclaimer', JSON.stringify(true));
    }
    onUpdateDropFiles = () => {
        this.setState({ filestoUpload: {} });
    }
    onDropAccepted = async (_filestoUpload) => {
        this.setState({ filestoUpload: _filestoUpload })
    }
    onDropRejected = (_filestoUpload) => {
        if (Object.keys(_filestoUpload).length > 5) {
            this.errorAlertMessage("You can only upload a maximum of 5 files");
        }
    }
    render() {
        let { showDisclaimerPopup } = this.state;
        const { alertMessageModelColor, alertMessageContent, alertMessageShowModal } = this.state;
        if (this.props.customWidth >= 600 && this.props.customWidth <= 1000) {
            return (
                <Dropzone
                    autoFocus={true}
                    onDrop={this.onDrop}
                    onDropRejected={this.onDropRejected}
                    onDropAccepted={this.onDropAccepted}
                    onError={this.onError}
                    noClick={false}
                    maxFiles={5}
                >
                    {({ getRootProps, getInputProps, isDragActive }) => (
                        <div {...getRootProps({ className: isDragActive ? 'gen-ai-answering-main gen-ai-answering2-main active-genAiAnsweringDropzone' : 'gen-ai-answering-main gen-ai-answering2-main' })}>
                            {/* <div className="gen-ai-answering-main gen-ai-answering2-main"> */}

                            {/* <GenAIClose /> */}
                            <GenAIMyAvatar />
                            {/* <div style={{ marginTop: "-40px", display: "flex", flexDirection: "row", justifyContent: "center", zIndex: "1" }}>
                        <div style={{ padding: "5px", backgroundColor: "#ffe597", fontSize: "larger", fontWeight: "bold" }}>Attention users: IMedical GenAI Answers is currently under maintenance. Some content types may not be available for the next 48 hours, including Scientific Responses, Labels, Posters and CSRs. This message will be removed once maintenance is compete.</div>
                    </div> */}
                            {(isDragActive) && (
                                <div className="gen-ai-answering-main-section-drop-zone">
                                    <div className="gen-ai-answering-main-section-message">Drag and drop file here</div>
                                </div>)}
                            <div className="gen-ai-answering-main-section">
                                {/* <div className="gen-ai-answering-main-img">
                                    <img className="bm-agent-image" src={chatbotHeaderIcon} alt="iMS profile image" style={{ backgroundColor: '#ffffff' }} />
                                </div> */}
                                    <GenAIAskQuestion isOpenInModelPopup={false} customWidth={this.state.customWidth} customHeight={this.state.customHeight} dropFiles={this.state.filestoUpload} onUpdateDropFiles={this.onUpdateDropFiles} key='GenAIHome' customeKey='GenAIHome' />
                                </div>
                            {/* <div className="gen-ai-answering-main-footer">
                                <div className="gen-ai-answering-main-footer-title">
                                    <span>Important: Validating GenAI Search Results in iMedical GenAI Answers</span>
                                </div>
                                <ul className="gen-ai-answering-main-footer-content">
                                    <li>
                                        iMedical GenAI Answers searches content sources available in iMedical Search. The source content is updated daily and only includes approved effective materials.
                                    </li>
                                    <li>
                                        GenAI Answers responses are intended for <i>INTERNAL USE ONLY</i>. Information contained in some content is confidential,  All existing processes and procedures regarding external communication, including Medical information discovered in GenAI Answers, continues to apply and must be strictly followed.
                                    </li>
                                    <li>
                                        All users are advised to validate summarized results using the citations provided with the referenced sources.
                                    </li>
                                    <li>
                                        GenAI is capable of providing convincing summaries that may not be complete or contain reasoning that a human would interpret differently. It is your responsibility to check the content, the points, observations and conclusions provided by iMedical GenAI Answers.
                                    </li>
                                    <p><a className="gen-ai-answering-main-footer-content-link" onClick={() => { this.setState({ showDisclaimerPopup: true }) }} >Gen Ai Adherence Policy</a></p>
                                </ul>
                            </div> */}
                            {showDisclaimerPopup && <GenAIAnsweringDisclaimer showPopup={showDisclaimerPopup} handleDisclaimerClose={this.handleDisclaimerClose} />}
                            {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                        </div>
                    )}
                </Dropzone>
            )
        }
        else if (this.props.customWidth > 1000) {
            return (
                <Dropzone
                    autoFocus={true}
                    onDrop={this.onDrop}
                    onDropRejected={this.onDropRejected}
                    onDropAccepted={this.onDropAccepted}
                    onError={this.onError}
                    noClick={false}
                    maxFiles={5}
                >
                    {({ getRootProps, getInputProps, isDragActive }) => (
                        <div {...getRootProps({ className: isDragActive ? 'gen-ai-answering-main gen-ai-answering2-main active-genAiAnsweringDropzone' : 'gen-ai-answering-main gen-ai-answering2-main' })}>
                            {/* <div className="gen-ai-answering-main gen-ai-answering2-main"> */}

                            {/* <GenAIClose /> */}
                            <GenAIMyAvatar />
                            {/* <div style={{ marginTop: "-40px", display: "flex", flexDirection: "row", justifyContent: "center", zIndex: "1" }}>
                        <div style={{ padding: "5px", backgroundColor: "#ffe597", fontSize: "larger", fontWeight: "bold" }}>Attention users: IMedical GenAI Answers is currently under maintenance. Some content types may not be available for the next 48 hours, including Scientific Responses, Labels, Posters and CSRs. This message will be removed once maintenance is compete.</div>
                    </div> */}
                            {(isDragActive) && (
                                <div className="gen-ai-answering-main-section-drop-zone">
                                    <div className="gen-ai-answering-main-section-message">Drag and drop file here</div>
                                </div>)}
                            <div className="gen-ai-answering-main-section">
                                {/* <div className="gen-ai-answering-main-img">
                                    <img className="bm-agent-image" src={chatbotHeaderIcon} alt="iMS profile image" style={{ backgroundColor: '#ffffff' }} />
                                </div> */}
                                    <GenAIAskQuestion isOpenInModelPopup={false} customWidth={this.state.customWidth} customHeight={this.state.customHeight} dropFiles={this.state.filestoUpload} onUpdateDropFiles={this.onUpdateDropFiles} key='GenAIHome' customeKey='GenAIHome' />
                                </div>
                            {/* <div className="gen-ai-answering-main-footer">
                                <div className="gen-ai-answering-main-footer-title">
                                    <span>Important: Validating GenAI Search Results in iMedical GenAI Answers</span>
                                </div>
                                <ul className="gen-ai-answering-main-footer-content">
                                    <li>
                                        iMedical GenAI Answers searches content sources available in iMedical Search. The source content is updated daily and only includes approved effective materials.
                                    </li>
                                    <li>
                                        GenAI Answers responses are intended for <i>INTERNAL USE ONLY</i>. Information contained in some content is confidential,  All existing processes and procedures regarding external communication, including Medical information discovered in GenAI Answers, continues to apply and must be strictly followed.
                                    </li>
                                    <li>
                                        All users are advised to validate summarized results using the citations provided with the referenced sources.
                                    </li>
                                    <li>
                                        GenAI is capable of providing convincing summaries that may not be complete or contain reasoning that a human would interpret differently. It is your responsibility to check the content, the points, observations and conclusions provided by iMedical GenAI Answers.
                                    </li>
                                    <p><a className="gen-ai-answering-main-footer-content-link" onClick={() => { this.setState({ showDisclaimerPopup: true }) }} >Gen Ai Adherence Policy</a></p>
                                </ul>
                            </div> */}
                            {showDisclaimerPopup && <GenAIAnsweringDisclaimer showPopup={showDisclaimerPopup} handleDisclaimerClose={this.handleDisclaimerClose} />}
                            {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                        </div>
                    )}
                </Dropzone>
            )
        }
    }

}
export default withRouter(GenAIHome);